import { useReduxState } from 'hooks';
import { Icon } from 'components/common/icons';
import { TaskPointsBadge } from '.';

const FillInAnswer = ({
  contentData,
  maxScore,
  score,
  answers,
  correctAnswers
}) => {
  const { theme } = useReduxState();

  return (
    <div className="answer">
      <div className="content">
        {contentData
          ? contentData.map((paragraph, i) => {
              return (
                <div style={{ minHeight: '1.5em', margin: '5px 0' }} key={i}>
                  {paragraph.map((paragraphContentItem, j) => {
                    if (paragraphContentItem.type === 'answer') {
                      const answer = correctAnswers?.find(
                        (a) => a.id === paragraphContentItem.id
                      );
                      const isCorrect = answer?.correct;
                      return (
                        <div
                          key={j}
                          style={{
                            backgroundColor: 'white',
                            display: 'inline-block',
                            padding: '3px 5px',
                            borderRadius: '4px',
                            margin: '2px'
                          }}
                        >
                          {
                            answers.find(
                              (a) => a.id === paragraphContentItem.id
                            )?.answer
                          }

                          <Icon
                            icon={isCorrect ? 'check' : 'times'}
                            style={{
                              color: isCorrect
                                ? theme.successStandaloneColor
                                : theme.dangerColor,
                              margin: '0 0 0 7px',
                              fontSize: '1rem',
                              position: 'relative',
                              top: -2
                            }}
                            fixedWidth={true}
                          />
                        </div>
                      );
                    }
                    return (
                      <span
                        dangerouslySetInnerHTML={{
                          __html: paragraphContentItem.content
                        }}
                        key={j}
                      />
                    );
                  })}
                </div>
              );
            })
          : null}
      </div>

      <TaskPointsBadge maxPoints={maxScore} points={score} />
    </div>
  );
};

export default FillInAnswer;
